import { metricLabels } from "@nabla/api";

export const designCopy = {
  lugares: {
    visaoGeral: "Visão geral",
    registro: "Registro",
    regras: "Regras",
    contas: "Contas e dados",
    pessoas: "Pessoas",
    conversa: "Conversa",
    conversas: "Conversas",
    mudanca: (alvo: string) => `Mudança em ${alvo}`,
    semMudanca: "Esta mudança não existe nesta empresa.",
    campanhaFora: "Esta campanha não está entre as que a Nabla acompanha.",
  },
  enviando: "Enviando…",
  tentarDeNovo: "Tentar de novo",
  cancelar: "Cancelar",
  dispensar: "Dispensar",
  copiar: "Copiar",
  copiado: "Copiado",
  abrirNoGerenciador: "Abrir no Gerenciador ↗",
  avaliar: "Avaliar",
  conferirDeNovo: "Conferir de novo",
  desfazer: "Desfazer",
  perguntar: "Pergunte sobre isto…",
  nadaEsperando: "Nada esperando você.",
  porque: "Por quê?",
  semPorque: "Diga por quê, em poucas palavras.",
  opcional: "(opcional)",
  deNovoAs: (hora: string) => `Dá para atualizar de novo às ${hora}.`,
  quem: { aNabla: "a Nabla", terminal: (rotulo: string) => `${rotulo} (pelo terminal)`, fora: "Fora da Nabla" },
  fonte: { meta: "Meta", shopify: "loja", asaas: "Asaas" },
  alerta: {
    "leitura-falhou": (daFonte: string, hora: string, motivo: string) => `A leitura ${daFonte} falhou às ${hora}: ${motivo}.`,
    "dados-atrasados": (daFonte: string, quando: string) => `A última leitura ${daFonte} é de ${quando}: estes números podem estar velhos.`,
  },
  statusSemGenero: { ACTIVE: "no ar", PAUSED: "em pausa" },
  modo: { shadow: "Sombra", act: "Age" },
  saude: {
    agendaAtrasada: "Agenda atrasada",
    agendaParada: (hora: string) => `Agenda parada desde ${hora}`,
    rodadaFalhou: (quando: string) => `Rodada da Nabla falhou ${quando}`,
    rodadaIlegivel: (quando: string) => `Rodada da Nabla ${quando} sem relatório legível`,
  },
  conversa: {
    "na-fila": "na fila", pensando: "pensando…", pronta: "respondida", vista: "vista", falhou: "falhou", "espera-voce": "espera você",
  },
  dinheiro: {
    formato: (simbolo: string) => `Use um valor em ${simbolo}, como 300 ou 300,50.`,
    maiorQueZero: "O orçamento precisa ser maior que zero.",
  },
  semConexao: "Sem conexão com a Nabla: não deu para saber se o pedido chegou. Tente de novo.",
  erros: {
    "sem-permissao": "Você não tem permissão para isso; peça a um admin.",
    csrf: "A página ficou desatualizada. Recarregue e tente de novo.",
    "nao-encontrado": "Não achamos isso nesta empresa.",
    "fora-do-escopo": "Isto não está entre as campanhas que a Nabla acompanha.",
    "chave-reutilizada": "Este pedido já foi enviado com outro conteúdo. Recarregue a tela.",
    "revisao-mudou": "Esta mudança tem uma versão nova. Olhe de novo.",
    "regras-mudaram": "As regras mudaram enquanto você editava. Veja a versão nova e edite de novo.",
    "aprovacao-vencida": "A aprovação venceu antes de ser escrita. Nada foi escrito.",
    "escrita-ja-comecou": "A escrita desta mudança já começou: não há mais aprovação para cancelar. Depois de escrita, use “Desfazer”.",
    sombra: "Esta conta está em sombra: a Nabla não escreve nela.",
    ocupado: "Há outra mudança neste objeto ainda sem resultado. Confira aquela primeiro.",
    devagar: "Muitos pedidos seguidos. Espere um pouco.",
    "gateway-fora": "A Nabla não responde agora. Nada foi enviado.",
    "conversa-indisponivel": "A Nabla não está disponível para perguntas agora.",
    interno: "Algo deu errado do nosso lado. Tente de novo; se continuar, avise quem cuida da Nabla.",
  },

  metrica: metricLabels,
  naoCalculado: "número não calculado",
  naoCalculadoExplica: "A Nabla escreveu aqui um número que o código não calculou, e por isso ele não aparece.",
  naoConferidoExplica: "A Nabla escreveu este número, mas nenhuma ferramenta o retornou. Confira antes de usar.",
  incompleto: "incompleto",
  verComoTabela: "Ver como tabela",
  verComoGrafico: "Ver como gráfico",
  dia: "Dia",
  fechar: "Fechar",
  semValor: {
    "janelas-diferentes": "Os números cobrem períodos diferentes: a conta não é feita.",
    "niveis-diferentes": "Um número é de um nível e o outro de outro: a conta não é feita.",
    "moedas-diferentes": "As moedas são diferentes: a conta não é feita.",
    zero: "O divisor é zero neste período: não há valor.",
    "sem-dados": "Sem dados neste período.",
    "nao-disponivel": "Ainda não disponível.",
  },
  motivoDaFalha: {
    "limite-do-modelo": "o login do modelo da Nabla chegou ao limite de uso",
    "limite-do-meta": "o Meta limitou os pedidos por um tempo",
    "sem-acesso": "a Nabla está sem acesso para ler",
    "tempo-esgotado": "a resposta demorou demais",
    "sem-resposta": "não houve resposta",
    "resposta-inesperada": "a resposta veio diferente do esperado",
    outro: "o motivo está no registro da agenda, com quem cuida da Nabla",
  },
  lojaRecusa: {
    "claude-connector": {
      houve: (fonte: { readonly a: string }) => `A autorização da Nabla para ler ${fonte.a} venceu`,
      pedir: "Peça a quem cuida da instalação da Nabla para renovar a autorização da loja.",
    },
    "admin-api": {
      houve: (fonte: { readonly A: string }) => `${fonte.A} recusou o acesso da Nabla`,
      pedir: "Peça a quem cuida da instalação da Nabla para refazer o acesso à loja.",
    },
  },
  formula: {
    soma: "soma das campanhas",
    "investido-com-imposto": "investido × (1 + imposto do Meta)",
    "vendas-sobre-faturado": "vendas ÷ investido com imposto",
    "vendas-sobre-investido": "vendas ÷ investido (sem imposto)",
    "faturado-sobre-pedidos": (resultados: string) => `investido com imposto ÷ ${resultados}`,
    "investido-sobre-pedidos": (resultados: string) => `investido (sem imposto) ÷ ${resultados}`,
    "valor-meta-sobre-investido": "valor das compras segundo o Meta ÷ investido",
    "investido-sobre-compras-meta": "investido ÷ compras segundo o Meta",
    "cliques-sobre-impressoes": "cliques no link ÷ impressões",
    "custo-mil-impressoes": "investido ÷ impressões × 1.000",
    "investido-sobre-cliques": "investido ÷ cliques no link",
    "impressoes-sobre-alcance": "impressões ÷ pessoas alcançadas",
    "investido-sobre-checkouts": "investido ÷ checkouts iniciados",
    "investido-sobre-leads": "investido ÷ leads",
    "visualizacoes-3s-sobre-impressoes": "visualizações de 3 segundos ÷ impressões",
    "investido-sobre-vendas-loja": "investido ÷ vendas da loja inteira (todos os pedidos, com ou sem anúncio)",
    "vendas-loja-sobre-faturado": "vendas da loja inteira (todos os pedidos, com ou sem anúncio) ÷ investido com imposto",
    "vendas-loja-sobre-investido": "vendas da loja inteira (todos os pedidos, com ou sem anúncio) ÷ investido (sem imposto)",
    "carrinho-sobre-sessoes": "sessões com carrinho ÷ sessões na loja",
    "pedido-sobre-checkout": "sessões com pedido ÷ sessões no checkout",
    "por-dia-vezes-7": "gasto por dia × 7",
    "resultados-no-ritmo": (resultados: string) => `gasto em 7 dias × ${resultados} ÷ investido nos dias lidos`,
  },
  peloMenos: "≥",
  faltando: "faltando",
  amadurecendo: "o Meta ainda pode revisar",
  cobertura: { inteiro: "lido inteiro", parcial: "parcial", "sem-leitura": "sem leitura" },
  mostrarMais: "Mostrar mais",
} as const;

type Unread = { readonly kind: string; readonly message?: string };
export const viewProblem = (error: Unread): string =>
  (error.kind === "api" && error.message !== undefined ? error.message : designCopy.erros["nao-encontrado"]);
